import { useEffect } from "react";

export const useLockBodyScroll = (shouldLock) => {
    useEffect(() => {
        if (shouldLock) {
            const originalOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';

            return () => {
                document.body.style.overflow = originalOverflow;
            };
        }
    }, [shouldLock]);
};